
/**
 * Special component for Bimini dessert section.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.0.0
 * @copyright  Copyright (C) 2022-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2022-10-17 (1.0.0) (jhoward)
 *      - Copy <Bimini_dessert> component from <Romanza_defaultSection>.
 *
 *    2023-04-17 (1.1.0) (jhoward)
 *      - Refactor <Bimini_dessert> to use TypeScript.
 *      - <Bimini_dessert> section prop is required.
 *      - Refactor <Bimini_dessert> to use helper functions for computed properties.
 *
 *  2023-08-23 (1.2.0) (jhoward)
 *    - Use <menu-version> in <Bimini_dessert>.
 *
 *  2025-02-11 (1.3.0) (jhoward)
 *    - Add <menu-schedules> to the <Bimini_dessert> component if in admin view.
 *
 *  2025-04-08 (2.0.0) (jhoward)
 *    - Use <bimini-default-section> in <bimini_dessert>.
 */

import {defineComponent, PropType} from "vue";
import {ALLOWED_ITEM_COMPONENTS, Menu, MenuSection} from "../defs";
import BiminiDefaultSection from "./Bimini_defaultSection.vue";

export default defineComponent({
  components: {
    BiminiDefaultSection,
  },
  name: "Bimini_dessert",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    menuItemComponent: {
      type: String,
      default: '',
      validate: (value: string) => '' === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    },
  }
})
